import { Action } from 'typescript-fsa';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../store';
import { ChartComponent } from '../components/ChartComponent';

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => ({ dispatch });
const mapStateToProps = (state: AppState) => state;

export default connect(mapStateToProps, mapDispatchToProps)(ChartComponent);
